import axios from 'axios';

export default class DownloadUtils {
    static getMimeType(url) {
        const urlWithoutQuery = url.split('?')[0];
        const extension = (urlWithoutQuery.split('.').pop() || '').toLowerCase();
        switch (extension) {
            case 'jpg':
            case 'jpeg':
                return 'image/jpeg';
            case 'png':
                return 'image/png';
            case 'gif':
                return 'image/gif';
            case 'webp':
                return 'image/webp';
            // Add more formats as needed
            default:
                return 'application/octet-stream'; // Default to binary stream. Adjust if necessary.
        }
    }

    static async downloadImageFromPresignedUrl(presignedUrl) {
        try {
            const mimeType = this.getMimeType(presignedUrl);
            console.log(
                `DownloadUtils downloadImageFromPresignedUrl mimeType: ${mimeType}, presignedUrl: ${presignedUrl}`,
            );

            // Make a GET request to the presigned URL and capture the response
            const response = await axios.get(presignedUrl, { responseType: 'blob' });

            // Log the ETag header from the response
            const eTag = response.headers['etag'];
            console.log(`Downloaded image ETag: ${eTag}`);

            const blob = new Blob([response.data], { type: mimeType });

            return new Promise((resolve) => {
                // Convert blob to base64
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                    const base64data = reader.result;
                    // You might want to resolve both base64data and eTag if needed outside
                    resolve({ base64data, eTag }); // Return the image data along with ETag
                };
            });
        } catch (error) {
            // Log the error
            console.error(`Error downloading image from presigned URL: ${error}`);
            // You can also rethrow the error or handle it differently if needed
            throw error;
        }
    }
}
